export default __webpack_public_path__ + "static/media/partner_logo_15.2905a77b.png";